import apiClient from '../../shared/auth/services'

export const satsueiGuideService = {
  // Get satsuei memo category list (for dropdown)
  async getSatsueiMemoCategory() {
    try {
      const response = await apiClient.post('/getSatsueiMemoCategory', {
        isContainSatsueiMemoColumn: false
      })
      return response.data
    } catch (error) {
      console.error('Get satsuei memo category error:', error)
      throw error
    }
  },

  // Get satsuei guide list
  async getSatsueiGuideList(satsueiMemoCategoryId) {
    try {
      const response = await apiClient.post('/getSatsueiGuideList', {
        satsueiMemoCategoryId,
        isContainDeleted: true
      })
      return response.data
    } catch (error) {
      console.error('Get satsuei guide list error:', error)
      throw error
    }
  },

  // Get satsuei guide detail list
  async getSatsueiGuideDetailList(satsueiMemoCategoryId, satsueiGuideId) {
    try {
      const response = await apiClient.post('/getSatsueiGuideDetailList', {
        satsueiMemoCategoryId,
        satsueiGuideId
      })
      return response.data
    } catch (error) {
      console.error('Get satsuei guide detail list error:', error)
      throw error
    }
  },

  // Add satsuei guide list
  async addSatsueiGuideList(satsueiGuideList) {
    try {
      const response = await apiClient.post('/addSatsueiGuideList', {
        satsueiGuideList
      })
      return response.data
    } catch (error) {
      console.error('Add satsuei guide list error:', error)
      throw error
    }
  },

  // Update satsuei guide list
  async updateSatsueiGuideList(satsueiGuideList) {
    try {
      const response = await apiClient.post('/updateSatsueiGuideList', {
        satsueiGuideList
      })
      return response.data
    } catch (error) {
      console.error('Update satsuei guide list error:', error)
      throw error
    }
  },

  // Remove satsuei guide list
  async removeSatsueiGuideList(satsueiGuideList) {
    try {
      const response = await apiClient.post('/removeSatsueiGuideList', {
        satsueiGuideList
      })
      return response.data
    } catch (error) {
      console.error('Remove satsuei guide list error:', error)
      throw error
    }
  },

  // Add satsuei guide detail list
  async addSatsueiGuideDetailList(satsueiGuideDetailList) {
    try {
      const response = await apiClient.post('/addSatsueiGuideDetailList', {
        satsueiGuideDetailList
      })
      return response.data
    } catch (error) {
      console.error('Add satsuei guide detail list error:', error)
      throw error
    }
  },

  // Update satsuei guide detail list
  async updateSatsueiGuideDetailList(satsueiGuideDetailList) {
    try {
      const response = await apiClient.post('/updateSatsueiGuideDetailList', {
        satsueiGuideDetailList
      })
      return response.data
    } catch (error) {
      console.error('Update satsuei guide detail list error:', error)
      throw error
    }
  },

  // Remove satsuei guide detail list
  async removeSatsueiGuideDetailList(satsueiGuideDetailList) {
    try {
      const response = await apiClient.post('/removeSatsueiGuideDetailList', {
        satsueiGuideDetailList
      })
      return response.data
    } catch (error) {
      console.error('Remove satsuei guide detail list error:', error)
      throw error
    }
  },

  // Upload satsuei guide image
  async uploadSatsueiGuideImage(formData) {
    try {
      const response = await apiClient.post('/uploadSatsueiGuideImage', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error('Upload satsuei guide image error:', error)
      throw error
    }
  },

  // Get image as blob with authentication
  async getImage(satsueiMemoCategoryId, satsueiGuideId, satsueiGuideDetailId, filenameExtension) {
    try {
      // Handle satsueiMemoCategoryId of 0 (unspecified)
      const params = {
        type: 'satsueiGuideImage',
        satsueiMemoCategoryId: satsueiMemoCategoryId || 0,
        satsueiGuideId,
        satsueiGuideDetailId,
        filenameExtension,
        filename: `${satsueiGuideId}_${satsueiGuideDetailId}.${filenameExtension}`
      }
      
      const response = await apiClient.get('/getImage', {
        params,
        responseType: 'blob',
        headers: { Accept: 'image/jpeg' }
      })
      return URL.createObjectURL(response.data)
    } catch (error) {
      console.error('Failed to get image:', error)
      throw error
    }
  }
}
